export class Persona{
    constructor(){
        this.restablecerPersona();
    }

    idPersona: number;
    razonSocial: string;
    tipoDocumentoText: string;
    tipoDocumento: number;
    numeroDocumento: string;
    apellidoUno: string;
    codigoAsegurado: number;
    fechaExpedicion: string;
    cupoOperativo: string;
    cupoDisponible: string;
    cumulo: string;
    fechaCupovigenciahasta : string;

    restablecerPersona(){
        this.idPersona=0;
        this.tipoDocumento=null;
        this.apellidoUno="";
        this.tipoDocumentoText="";
        this.numeroDocumento="";
        this.razonSocial="";
        this.fechaExpedicion="";
        this.fechaCupovigenciahasta = "";
    }

    static crearPersona(idPersona: number,
                        nombreUno: string,
                        nombreDos: string,
                        apellidoUno: string,
                        apellidoDos: string,
                        tipoDocumento: number,
                        tipoDocumentoText: string,
                        numeroDocumento: string,
                        codigoAsegurado: number, fechaCupovigenciahasta : string = ""): Persona {
        let persona=new Persona();

        persona.razonSocial=this.obtenerRazonSocial(nombreUno, nombreDos, apellidoUno, apellidoDos);
        persona.idPersona=idPersona;
        persona.apellidoUno=apellidoUno;
        persona.tipoDocumento=tipoDocumento;
        persona.tipoDocumentoText=tipoDocumentoText;
        persona.numeroDocumento=numeroDocumento;
        persona.codigoAsegurado=codigoAsegurado;
        persona.fechaCupovigenciahasta = fechaCupovigenciahasta;

        return persona;
    }

    static crearTomadorDesdeParticipante(participante: Participante){
        let tomador=new Persona();
        tomador.idPersona=participante.idPersona;
        tomador.apellidoUno=participante.apellidoUno;
        tomador.razonSocial=participante.razonSocial;
        tomador.numeroDocumento=participante.numeroDocumento;
        tomador.tipoDocumento=participante.tipoDocumento;
        tomador.tipoDocumentoText=participante.tipoDocumentoText;
        tomador.codigoAsegurado=participante.codigoAsegurado;
        return tomador;
    }

    static obtenerRazonSocial(nombreUno: string, nombreDos: string, apellidoUno: string, apellidoDos: string){
        let nombres=(nombreUno!=null?nombreUno:"")+(nombreDos!=null?" "+nombreDos:"");
        let apellidos=(apellidoUno!=null?" "+apellidoUno:"")+(apellidoDos!=null?" "+apellidoDos:"");
        return nombres+apellidos;
    }
}

export class Participante extends Persona{
    porcentajeParticipacion: number;

    constructor(persona: Persona, codAsegurado: number, porcentajeParticipacion: number=0){
        super();
        this.idPersona=persona.idPersona;
        this.apellidoUno=persona.apellidoUno;
        this.razonSocial=persona.razonSocial;
        this.tipoDocumento=persona.tipoDocumento;
        this.tipoDocumentoText=persona.tipoDocumentoText;
        this.numeroDocumento=persona.numeroDocumento;
        this.porcentajeParticipacion=null;
        this.codigoAsegurado=codAsegurado;
        this.porcentajeParticipacion=porcentajeParticipacion;
        this.cupoOperativo=persona.cupoOperativo;
        this.cupoDisponible=persona.cupoDisponible;
        this.cumulo=persona.cumulo;
        this.fechaCupovigenciahasta = persona.fechaCupovigenciahasta;

    }

}
